import { atom } from 'recoil';

import { dashboardVersionInterface } from '../interfaces/ui_interfaces';
import GeoJSON from 'geojson';
import { atomLocalStorageEffect } from '../../utils/atomLocalStorageEffect';
import type { DeviceMode } from './device_atoms';

export type NavState =
  | 'device-metrics'
  | 'accounts-page'
  | 'settings-page'
  | 'battery-calculator';

export const navStateAtom = atom<NavState>({
  key: 'navState',
  default: 'device-metrics',
});

export const dashboardVersionAtom = atom<dashboardVersionInterface>({
  key: 'dashboardVersion',
  default: {
    version: '2.0.0',
  },
});

export const defaultLocationAtom = atom<GeoJSON.Point>({
  key: 'defaultLocation',
  default: {
    type: 'Point',
    coordinates: [0.0, 0.0],
  },
});

export type MapStyle = 'streets' | 'satellite';

export const mapStyleAtom = atom<MapStyle>({
  key: 'mapStyle',
  default: 'streets',
  effects: [atomLocalStorageEffect('mapStyle')],
});

export const isFetchingDeviceListAtom = atom<Record<DeviceMode, boolean>>({
  key: 'isFetchingDeviceList',
  default: {
    live: false,
    archived: false,
  },
});

export const isFetchingDeviceDataAtom = atom<boolean>({
  key: 'isFetchingDeviceData',
  default: false,
});
